import React, { useState } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { NHOMTIEUCHI_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200 } from '../../../../../utils/define';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';

const schema = yup.object().shape({
    phan: yup.number().required(messageError.emptyMessage).min(1, 'Phần phải lớn hơn 0'),
    diemToiDa: yup.number().required(messageError.emptyMessage).min(0, 'Điểm tối đa không được nhỏ hơn 0'),
    tenNhomTieuChi: yup.string().required(messageError.emptyMessage).max(255, 'Tên nhóm tiêu chí không được vượt quá 255 ký tự')
});

const NhomTieuChiAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(NHOMTIEUCHI_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới nhóm tiêu chí</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        phan: 1,
                        tenNhomTieuChi: '',
                        diemToiDa: 0,
                        moTa: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Phần',
                                        name: 'phan',
                                        type: 'number',
                                        value: values.phan,
                                        onChange: handleChange,
                                        isInvalid: errors.phan,
                                        error: errors.phan
                                    },
                                    {
                                        label: 'Tên nhóm tiêu chí',
                                        name: 'tenNhomTieuChi',
                                        value: values.tenNhomTieuChi,
                                        onChange: handleChange,
                                        isInvalid: errors.tenNhomTieuChi,
                                        error: errors.tenNhomTieuChi
                                    },
                                    {
                                        label: 'Điểm tối đa',
                                        name: 'diemToiDa',
                                        type: 'number',
                                        value: values.diemToiDa,
                                        onChange: handleChange,
                                        isInvalid: errors.diemToiDa,
                                        error: errors.diemToiDa
                                    },
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Col sm="10">
                                        <Editor
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'moTa',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.NHOMTIEUCHI_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default NhomTieuChiAdd;
